import moment from 'moment';
import _ from 'lodash';

export default (startingFrom, numberOfDays) => {
	startingFrom = moment.utc(startingFrom);
	const addHours = (day, hours) => day.clone().add(hours, 'hours').toISOString();

	const getDay = day => startingFrom.clone().add(day, 'days').startOf('day');

	const isWeekDay = day => _.range(1, 6).includes(day.weekday());

	const calculateTimeSlots = day => [{
		startDatetime: addHours(day, 8),
		endDatetime: addHours(day, 12)
	}, {
		startDatetime: addHours(day, 12),
		endDatetime: addHours(day, 17)
	}];

	return _.flatten(_.range(0, numberOfDays + 1)
		.map(getDay)
		.filter(isWeekDay)
		.map(calculateTimeSlots));
};
